Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-ajax-buttons', function (envelope) {

        var $context = envelope.message.data.context,
            $control = $('.x-product-details-ajax-buttons', $context);

        if ($control.length < 1)
            return;

        $control.on('click', '.js-add-to-cart', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);

            if ($this.hasClass('disabled') || $this.is(':disabled'))
                return;

            var state = Vendd.Product.Controller.getState();
            var id = state.parentId,
	            skuId = state.selectedId,
                colorId = state.selectedColorId,
	            path = state.path,
                qty = (state.qty ? stringToNumber(state.qty) : null) || 1,
                extraAttributes = [],
                bundleItems = state.bundleItems,
                recipeItems = state.recipeItems,
                comboItems = state.comboItems;

            $('.x-editable-extra-properties .editable-attribute').each(function (el) {
                var $attr = $(this);
                var code = $attr.data('attribute');
                var value = $('input', $attr).val();
                extraAttributes.push({ code: code, value: value });

            });
            var itemInfo = {
                minQuantity: state.minQuantity,
                maxQuantity: state.maxQuantity,
                quanta: state.quanta
            };

            var enhancedInfo = { color: '', size: '', list: 'productDetails', colorId: colorId };

            if ($this.closest('.x-product-details-sticky-bar').length > 0) {
                $('html, body').animate({ scrollTop: 30 }, 1);
            }

            var vendd = getParentOrSelfVendd();
            vendd.MessageBus.publishAsync($control.get(0), new vendd.Cart.Messages.Add(id, skuId, path, qty, '', extraAttributes, bundleItems, recipeItems, comboItems, itemInfo, enhancedInfo));
            vendd.MessageBus.publishAsync($control.get(0), new vendd.Widget.Messages.OpenWidget(vendd.Widget.CartWidget, false));
        });

        $control.on('click', '.js-add-to-wishlist', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);

            if ($this.hasClass('disabled') || $this.is(':disabled') || $this.hasClass('already-in-wishlist'))
                return;

            
            $("body,html").animate({ scrollTop: 30 }, 1);

            var state = Vendd.Product.Controller.getState();
            var id = state.parentId,
	            skuId = state.selectedId,
	            path = state.path,
	            qty = (state.qty ? stringToNumber(state.qty) : null) || 1,
	            extraAttributes = [],
	            bundleItems = state.bundleItems;

            var vendd = getParentOrSelfVendd();

            if (LhApp.Context.MultipleWishlistsEnabled && $('.js-wishlist-lists', $control).length > 0) {
                LhApp.Function.hideAllProductWishlists();
                var product = { id: id, skuId: skuId, path: path, qty: qty };
                LhApp.Function.showProductWishlists($control, product);

            } else {
                $this.addClass('already-in-wishlist');
                vendd.MessageBus.publishAsync($control.get(0), new vendd.Wishlist.Messages.Add(id, skuId, path, qty, extraAttributes, bundleItems));
                vendd.MessageBus.publishAsync($control.get(0), new vendd.Widget.Messages.OpenWidget(vendd.Widget.WishlistWidget, false));
            }

        });

        $control.on('click', '.js-show-recipe', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);

            if ($this.hasClass('disabled') || $this.is(':disabled'))
                return;

            $this.addClass('active');

            var state = Vendd.Product.Controller.getState();
            var id = state.parentId,
                skuId = state.selectedId,
                path = state.path,
                qty = (state.qty ? stringToNumber(state.qty) : null) || 1,
                extraAttributes = [],
                bundleItems = state.bundleItems;

            var vendd = getParentOrSelfVendd();
            vendd.MessageBus.publishAsync($control.get(0), new vendd.Recipe.Messages.GetModel(id));
        });

        $control.on('click', '.js-add-to-productCompare', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var state = Vendd.Product.Controller.getState();
            var id = state.parentId,
                skuId = state.selectedId;

            var vendd = getParentOrSelfVendd();
            vendd.MessageBus.publishAsync($control.get(0), new vendd.ProductCompare.Messages.Add(id, skuId));
            vendd.MessageBus.publishAsync($control.get(0), new vendd.Widget.Messages.OpenWidget(vendd.Widget.ProductCompareWidget, false));
        });

        $control.on('click', '.js-quick-view', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);

            if ($this.hasClass('disabled') || $this.is(':disabled'))
                return;

            var state = Vendd.Product.Controller.getState();
            var id = state.parentId,
	            skuId = state.selectedId,
	            path = state.path,
	            qty = ($('input[name="qty"]').val() ? stringToNumber($('input[name="qty"]').val()) : null) || 1;
            //console.log(state);
            extraAttributes = "";
            //debugger;
            Vendd.MessageBus.publishAsync($control.get(0), new Vendd.Cart.Messages.Add(id, skuId, path, qty, extraAttributes));
            Vendd.MessageBus.publishAsync($control.get(0), new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));
            var path = $('.x-product-details').data('path');
            var Href = '/pages/productdetailspopup.aspx?iid=' + id + '&path=' + path + '&Quantity=' + qty;
            $.fancybox.open({
                href: Href,
                type: 'iframe',
                maxWidth: 1040,
                //maxHeight: 745,
                fitToView: false,
                //width: '100%',
                //height: '100%',
                autoSize: false,
                closeClick: false,
                openEffect: 'none',
                closeEffect: 'none',
                padding: 0,
                beforeShow: function () {
                    this.width = ($('.fancybox-iframe').contents().find('.product-details-popup').width());
                    this.height = ($('.fancybox-iframe').contents().find('html').height());
                }
            });
        });

        $control.on('click', '.js-add-sku-to-cart', function (e) {

            e.preventDefault();
            e.stopPropagation();

            var $this = $(this),
                $box, $qty, $tooltip,
                id, skuId, path, qty, extraAttributes, bundleItems;

            if ($this.hasClass('disabled') || $this.is(':disabled'))
                return;

            $box = $this.closest('.sku-product-box');
            $tooltip = $('.js-tooltip', $box);
            $qty = $('.js-qty-input', $box);

            id = $box.data('productid');
            skuId = $box.data('variantid');
            path = $box.data('path');

            qty = ($qty.val() ? stringToNumber($qty.val()) : null) || 0;
            extraAttributes = [];
            bundleItems = [];
            recipeItems = [];
            comboItems = [];

            if ($this.hasClass('inactive')) {
                $tooltip.addClass('visible');
                setTimeout(function () {
                    $tooltip.removeClass('visible');
                }, 3000);
                return;
            }

            var itemInfo = {
                minQuantity: parseInt($box.data('min-quantity') || 0),
                maxQuantity: parseInt($box.data('max-quantity') || 0),
                quanta: parseInt($box.data('quanta') || 0)
            };

            var state = Vendd.Product.Controller.getState();
            var enhancedInfo = { color: '', size: '', list: 'productDetails', colorId: state.selectedColorId };


            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Cart.Messages.Add(id, skuId, path, qty, '', extraAttributes, bundleItems, recipeItems, comboItems, itemInfo, enhancedInfo));
            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));
        });

        $control.on('click', '.js-notify-button', function (e) {

            var $this = $(this);
            var $productWrapper = $('.x-product-details'),
                $availabilityForm = $('.x-product-details-availability-notification', $productWrapper);

            if ($productWrapper.length < 1)
                return;

            if ($availabilityForm.hasClass('hidden')) {
                $availabilityForm.removeClass('hidden');
            } else {
                $availabilityForm.addClass('hidden');
            }
        });

        $(document).on('click', function (e) {
            var $productWrapper = $('.x-product-details'),
                $availabilityForm = $('.x-product-details-availability-notification', $productWrapper),
                $notifyBtn = $('.js-notify-button', $productWrapper);
            if (!$availabilityForm.is(e.target)
                && $availabilityForm.has(e.target).length === 0
                && !$notifyBtn.is(e.target)
                && $notifyBtn.has(e.target).length === 0) {

                $availabilityForm.addClass('hidden');
            }
        });

    });
});

//Vendd.MessageBus.subscribe(Vendd.UserWishlist.Messages.GetModelSuccess, $control, LhApp.Function.hideAllProductWishlists);

